import { XIcon } from "lucide-react";
import { useNotificationContext } from "../../context/NotificationContext";

const NotificationMessage = () => {
    const {
        isNotification,
        title,
        message,
        isVisible,
        onClose
    } = useNotificationContext();

    return (
        <div className={`fixed top-0 left-10 right-10 z-50 transition-transform duration-500 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
            <div className={`p-4 ${isNotification ? 'bg-blue-800' : 'bg-red-800'} text-white rounded-b-lg`}>
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        {isNotification ? '✅' : '❌'}
                        <span className="ml-2 text-m font-bold">{title}</span>
                    </div>
                    <button onClick={onClose} className="text-white-500 hover:text-white-700">
                        <XIcon />
                    </button>
                </div>
                <p className="text-sm font-semibold mt-1">{message}</p>
            </div>
        </div>
    );
};

export default NotificationMessage;